<template>
  <el-dialog
    title="图片编辑"
    :visible.sync="visible"
    :width="dialogWidth"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">

    <div class="tui-image-editor"></div>

    <el-card
      shadow="never"
      style="margin-top: 10px">
      <el-tabs
        v-model="avtive"
        tab-position="bottom"
        @tab-click="tabClick">
        <el-tab-pane
          label="旋转"
          name="1">
          <div class="tool-wrap">
            <i
              class="el-icon-refresh-right icon-class"
              title="顺时针旋转90°"
              @click="rolate(90)"></i>
            <i
              class="el-icon-refresh-left  icon-class"
              title="逆时针旋转90°"
              @click="rolate(-90)"></i>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="画笔"
          name="2">
          <div class="tool-wrap">

            <el-color-picker
              v-model="options.color"
              @change="colorChange"></el-color-picker>

            <el-slider
              v-model="options.width"
              :min="10"
              :max="30"
              class="slider-class"
              style="width: 100px"
              @change="sliderChange"></el-slider>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <template slot="footer">
      <el-button
        :loading="loading"
        @click="reset">重 置</el-button>
      <el-button
        :loading="loading"
        @click="toggleModal">取 消</el-button>
      <!-- <el-button @click="rolate"
                 :loading="loading"
                 icon="el-icon-refresh-right">旋转</el-button>
      <el-button @click="dama"
                 :loading="loading">dama</el-button> -->
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">提 交</el-button>
    </template>
  </el-dialog>
</template>-
<script>
import ImageEditor from 'tui-image-editor'
export default {
  name: 'TuiImageEditor',
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      visible: false,
      imageEditor: null,
      dialogWidth: '700px',
      imageUrl: null,
      index: -1,
      avtive: '1',
      options: {
        width: 30,
        color: 'rgb(255,255,255)'
      }
    }
  },
  methods: {
    toggleModal() {
      this.visible = !this.visible
    },
    handleClosed() { },
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(','); const mime = arr[0].match(/:(.*?);/)[1]

      const bstr = atob(arr[1]); let n = bstr.length; const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    handleSubmit() {
      const dataurl = this.imageEditor.toDataURL()
      //   this.canvas.toBlob(blob => {
      //     this.uploadFile(dataurl)
      //   })
      this.uploadFile(this.dataURLtoBlob(dataurl))
    },
    uploadFile(file) {
      this.loading = true
      const form = new FormData()
      form.append('file', file)
      this.$store.dispatch('common/uploadfile', {
        payload: form,
        success: (res) => {
          this.callback && this.callback({
            url: res.data.viewUrl + res.data.filepath,
            filepath: res.data.filepath
          }, this.index)
          this.loading = false
          this.toggleModal()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    reset() {
      this.imageEditor.loadImageFromURL(this.imageUrl, 'SampleImage').then(sizeValue => {
        console.log(sizeValue)
        this.imageEditor.clearUndoStack()
      })
    },

    tabClick(e) {
      console.log(e)
      if (e.name === '2') {
        this.dama()
      } else {
        this.imageEditor.stopDrawingMode()
      }
    },
    rolate(deg) {
      this.imageEditor.rotate(deg)
    },
    colorChange() {
      this.imageEditor.setBrush({
        ...this.options
      })
    },
    sliderChange() {
      this.imageEditor.setBrush({
        ...this.options
      })
    },
    dama() {
      this.imageEditor.startDrawingMode('FREE_DRAWING', {
        width: 30,
        color: this.options.color
      })
    },
    init(imageUrl, index) {
      this.toggleModal()
      this.$nextTick(() => {
        this.imageUrl = imageUrl
        this.index = index
        if (this.imageEditor) {
          this.imageEditor.loadImageFromURL(imageUrl, 'SampleImage').then(sizeValue => {
            console.log(sizeValue)
            this.imageEditor.clearUndoStack()
          })
        } else {
          this.imageEditor = new ImageEditor('.tui-image-editor', {
            cssMaxWidth: 700,
            cssMaxHeight: 500,
            selectionStyle: {
              cornerSize: 20,
              rotatingPointOffset: 70
            }
          })
          this.imageEditor.on('mousedown', function(event, originPointer) {
            console.log(event)
            console.log(originPointer)
          })
          this.imageEditor.loadImageFromURL(imageUrl, 'SampleImage').then(sizeValue => {
            console.log(sizeValue)
            this.imageEditor.clearUndoStack()
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.tui-image-editor {
  height: 500px;
}

.icon-class {
  cursor: pointer;
  font-size: 20px;
  margin-right: 10px;
}

.tool-wrap {
  display: flex;
  align-items: center;
}

.slider-class {
  margin-left: 10px;
}
</style>
